import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function mobilePhoneValidator(): ValidatorFn  {
    return (control: AbstractControl): ValidationErrors | null => {
        let error = { "invalidMobilePhoneValidator": true };
        let phoneInput = control.value;
        if(!phoneInput || phoneInput == '') return null;
        let mobilePhoneRegex = new RegExp("^[0][5][02-578][0-9]{7}$");
        let regexCharToReplace = /-/gi;
        let result = mobilePhoneRegex.test(phoneInput.replace(regexCharToReplace, ""));
        return result ? null : error;
    }
}